import { Component } from 'react';
import { FadeInGrow, AnimatedProgressCircle } from './Animations';

class WorkoutProgressModule extends Component {
	constructor(props) {
		super(props);

		this.state = {
			progress: this.props.progress,
			animate: this.props.animate,
		}

		this.moduleName = 'workout-progress';
	}

	renderInnerCircle(progress, animate) {
		return(
			<div className={ `${this.moduleName}__inner-circle` }>
				{
					animate ?
					<FadeInGrow>
						<h2 className={`${this.moduleName}__percentage`}>{progress.percentage}%</h2>
					</FadeInGrow>
					: 
					<h2 className={`${this.moduleName}__percentage`}>{progress.percentage}%</h2>
				}
			</div>
		);
	}
	
	renderCircle(progress, animate) {
		const progressCircleAngle = `${progress.degree}deg`;
		return (
				animate ?
				<AnimatedProgressCircle targetAngle={progress.degree}>
					{ this.renderInnerCircle(progress, animate) }
				</AnimatedProgressCircle>
				:
				<div 
					className={`${this.moduleName}__circle`} 
					style={{ '--progress-circle-angle': progressCircleAngle }}
				>
					{ this.renderInnerCircle(progress) }
				</div>
		)
	}

	renderContent(progress) {
		const animate = this.props.animate;
		let day = progress.currentDay;
		
		if ( progress.doneToday ) {
			day = progress.daysDone;
		}
		return (
			<div className={this.moduleName}>
				{
					this.renderCircle(progress, animate) 
				}
				<h4 className={ `${this.moduleName}__current-day` }>Day {day}</h4>
			</div>
		);
	}

	render() {
		const progress = this.props.progress;

	    return (
			this.renderContent(progress)
	    );
  	}
}

export default WorkoutProgressModule;